<template>
    <div v-if="mostrarDetalhe">
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            FISCALIZAÇÃO -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <detalhe titulo="Fornecedor" :size="size1">
                            {{ fiscalizacao.fornecedor }}
                        </detalhe>
                        <detalhe titulo="Contrato" :size="size1">
                            {{ fiscalizacao.codigoContrato }}
                        </detalhe>
                        <detalhe titulo="Processo de fiscalização" :size="size1">
                            {{ fiscalizacao.processoFiscalizacao }}
                        </detalhe>
                        <detalhe titulo="Descrição" :size="size1">
                            {{ fiscalizacao.descricao }}
                        </detalhe>
                        <detalhe titulo="Data da fiscalização" :size="size1">
                            {{fiscalizacao.dataFiscalizacao ? $moment(fiscalizacao.dataFiscalizacao).format('DD/MM/YYYY') : '' }}
                        </detalhe>
                        <detalhe titulo="Observação" :size="size1">
                            {{ fiscalizacao.observacao }}
                        </detalhe>
                    </b-card-body>
                    <b-card-footer>
                        <app-fiscalizacao-atualizar></app-fiscalizacao-atualizar>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-1"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <app-fiscalizacao-irregularidades-associadas
                @obterFiscalizacao="obterFiscalizacao()"
                @obterDetalheIrregularidadeFiscalizacao="obterDetalheIrregularidadeFiscalizacao"
                :fiscalizacao="fiscalizacao" 
                :irregularidades="fiscalizacao.irregularidades">
            </app-fiscalizacao-irregularidades-associadas>
        </b-row>
    </div>
    <div v-else>
        <router-view></router-view>   
    </div> 
</template>

<script>
import FiscalizacoesServicos from './FiscalizacoesServicos'
import FiscalizacaoAtualizar from './FiscalizacaoAtualizar.vue'
import FiscalizacaoIrregularidadesAssociadas from './FiscalizacaoIrregularidadesAssociadas.vue'

export default {

    data() {
        return {
            fiscalizacao: {},
            erros: [],
            usuario: {},
            size1: '150',
            irregularidadeFiscalizacaoSelecionada: null
        }
    },

    methods: {

        voltar() {
            this.$router.push({ name: 'Fiscalizações' })
        },

        obterDetalheIrregularidadeFiscalizacao(data) {
            this.$router.push({
                name: `IrregularidadeFiscalizacao_Detalhe`,
                params: {
                    fiscalizacaoId: data.idFiscalizacao,
                    idIrregularidadeFiscalizacao: data.idIrregularidadeFiscalizacao
                }
            })
        },

        obterFiscalizacao() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.obterFiscalizacao(this.$route.params.fiscalizacaoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.fiscalizacao = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        transferirParaAtualizacao() {
            this.$router.push({
                name: 'Usuarios_Atualizar',
                params: { usuarioId: this.$route.params.usuarioId }
            })
        },
    },

    computed: {
        mostrarDetalhe() {
            return this.$route.name === 'Fiscalizações_Detalhar'
        }
    },

    created() {
        this.operacao = 'DETALHAR'
        this.obterFiscalizacao()
    },

    watch: {
        $route(to, from) {
            if (from.name === 'IrregularidadeFiscalizacao_Avaliar') {
                this.obterFiscalizacao()
            } 
        },
    },

    components: {
        AppFiscalizacaoAtualizar: FiscalizacaoAtualizar,
        AppFiscalizacaoIrregularidadesAssociadas: FiscalizacaoIrregularidadesAssociadas
    }
}
</script>
